'use client';

import { useEffect } from 'react';
import { useGeoforgeStore } from '@/components/providers/geoforge-store-provider';
import { useCookiebotStatisticsConsent } from '@/hooks/use-cookiebot-statistics-consent';
import { loadDatadogRum } from '@/lib/datadog-rum';

/**
 * Tracks user context in Datadog RUM
 * Syncs the current user from the store with Datadog's user session tracking
 */
export default function DatadogUserTracker() {
  const currentUser = useGeoforgeStore(state => state.currentUser);
  const hasStatisticsConsent = useCookiebotStatisticsConsent();

  useEffect(() => {
    if (!hasStatisticsConsent) {
      return;
    }

    let isCancelled = false;

    async function syncDatadogUser() {
      const { datadogRum } = await loadDatadogRum();

      if (isCancelled) {
        return;
      }

      if (currentUser) {
        datadogRum.setUser({
          id: currentUser.id,
          email: currentUser.email,
          name: currentUser.display_name || currentUser.email.split('@')[0] || undefined,
        });
      } else {
        datadogRum.clearUser();
      }
    }

    void syncDatadogUser();

    return () => {
      isCancelled = true;
    };
  }, [currentUser, hasStatisticsConsent]);

  return null;
}
